import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection, ItemSection, SectionType } from '../itemSection';
import { Product } from '@/store/modules/product';
import store from '@/store';
import { ElementType } from '../element';
import { coffeeTableLegs } from '../legs/coffeeTableLegs';

export class CoffeeTableSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [
        new ItemSection(SectionType.BODY_COLOR, 'Kolor korpusu', []),
        new ItemSection(SectionType.LEGS, 'nóżki', []),
    ];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        this.applyLanguage();
        const furnitureShaders = store.getters.shaders.furniture;
        this.updateShaderSection(SectionType.BODY_COLOR, ElementType.BODY, furnitureShaders);
        this.updateLegsSection(product, coffeeTableLegs);
        return this.sections;
    }

    protected applyLanguage(): void {
        this.getSectionByType(SectionType.BODY_COLOR).text = this.scenePreview.$t('countertopColor');
        this.getSectionByType(SectionType.LEGS).text = this.scenePreview.$t('longLegs');
    }
}
